module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/icon19.d5b69bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/icon19.png
// module id = Iged
// module chunks = 0